import {
  getBrowserTimezone,
  getBrowserTimezoneGMT,
} from "@myvp/shared/src/functions/get-browser-timezone"

const inIframe = (() => {
  try {
    return window.self !== window.top
  } catch {
    return false
  }
})()

const staticProperties = {
  inIframe,
  platform: "Web",
  app_version: process.env.REACT_APP_VERSION,
  user_agent: navigator.userAgent,
}

/**
 * Returns data for:
 *
 * - the "device-properties" http header.
 * - saveBeacons api "device-properties" field
 */
export const getDeviceProperties = () => ({
  ...staticProperties,
  timezone: getBrowserTimezone(),
  timezoneOffset: getBrowserTimezoneGMT(),
  deviceWidth: screen.width,
  deviceHeight: screen.height,
  pixelDensity: window.devicePixelRatio,
  currentWidth: window.innerWidth,
  currentHeight: window.innerHeight,
})
